import { Stack, Autocomplete, TextField } from '@mui/material'
import { useState } from 'react'
import { MedicalQuery } from 'services/graphql/medicalService'
import { useQuery } from 'urql'

import * as SVG from 'assets/svg'
interface ItemIcdFormProps {
  index: number
  onRemove?: Function
  onSelected?: Function
  defaultValue?: any
}

export default function ItemIcdForm({
  index,
  onRemove,
  onSelected,
  defaultValue,
}: ItemIcdFormProps) {
  const [open, setOpen] = useState(false)
  const [isFirst, setIsFirst] = useState(true)
  const [icd10KeyCode, setIcd10KeyCode] = useState<string>(defaultValue.icdCode)
  const [icdApiData] = useQuery(
    MedicalQuery.getIcdTenListWithCode(icd10KeyCode),
  )

  const icd10PreData = []
  if (!icdApiData.fetching && !icdApiData.error) {
    icdApiData.data.getIcdTenList.map((item: any) =>
      icd10PreData.push({
        label: item.icdCode + ' ' + item.icdName,
        icdCode: item.icdCode,
        icdName: item.icdName,
      }),
    )
  }

  const onTextConsultChange = (event) => {
    setIsFirst(false)
    if (event.target.value.length > 3) {
      setIcd10KeyCode(event.target.value)
    }
  }
  return (
    <Stack
      direction={{ laptop: 'row' }}
      justifyContent="space-between"
      alignItems="center"
    >
      {!icdApiData.fetching && !icdApiData.error && (
        //alert(JSON.stringify())
        <>
          <Autocomplete
            open={open}
            onInputChange={(_, value) => {
              if (!isFirst) {
                if (value.length === 0) {
                  if (open) setOpen(false)
                } else {
                  if (!open) setOpen(true)
                }
              }
            }}
            onChange={(_, value) => onSelected(value)}
            onClose={() => setOpen(false)}
            disablePortal
            id={'combo-box-demo-' + index}
            className="w-[94%]"
            options={icd10PreData}
            value={defaultValue}
            noOptionsText="ไม่มีข้อมูล พิมพ์รหัสเพื่อค้นหา"
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                variant="outlined"
                onChange={onTextConsultChange}
              />
            )}
          />
          <div onClick={() => onRemove()}>
            <SVG.BtnDelete />
          </div>
        </>
      )}
    </Stack>
  )
}
